import type { ComponentOverride } from '../types';

export const MuiPagination: ComponentOverride<'MuiPagination'> = {
  MuiPagination: {
    defaultProps: {
      color: 'primary',
    },
  },
};
